module.exports = __webpack_public_path__ + "img/editLatex.f64855ba.svg";